import { fetchData } from "app/services/apiService";

export const caricaComuniByProvincia = (idProvincia) => {
  const apiUrl = `Comuni/ElencoComuniByProvincia/${idProvincia}`;
  return (dispatch) => {
    return dispatch(fetchData(apiUrl))
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };
}

export const caricaTuttiComuni = () => {
  const apiUrl = `Comuni/ElencoComuniModel`;
  return (dispatch) => {
    return dispatch(fetchData(apiUrl))
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };
}

export const caricaComuniTypeahed = (iniziaCon) => {
  const apiUrl = `Comuni/ElencoComuniTypeahead/${iniziaCon}`;
  return (dispatch) => {
    return dispatch(fetchData(apiUrl))
      .then((data) => {
        return data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  };
}

